import React, {useContext, useEffect} from "react"
import {AssociatePerformanceContext} from "./context/AssociatePerformanceContext";
import Row from "@amzn/meridian/row";
import Table, { TableRow, TableCell } from "@amzn/meridian/table"
import {AssociateFilterContext} from "./context/AssociateFilterContext";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";
import {getAliasFromLoginId, getRefreshInterval} from "../util/Util";
import RefreshTimer from "../util/RefreshTimer";

const AssociatePerformance = () => {
    const { states } = useContext(AssociateFilterContext)
    const {viewModel, dispatch} = useContext(AssociatePerformanceContext);

    const getData = () => {
        dispatch({type: 'LOAD_VIEW', data:{dispatcher: dispatch}});
    }

    useEffect(() => {
        getData()
        const interval = setInterval(() => {
            if (!document.hidden) {
                getData();
            }
        }, getRefreshInterval());
        return () => clearInterval(interval);
    }, []);

    const getAssociateLink = (loginId) => {
        let baseUrl = viewModel.baseURL.toString();
        if (baseUrl.includes('associateinduct')) {
            baseUrl = baseUrl.replace('associateinduct', 'search');
        } else {
            baseUrl = baseUrl.replace('induct', 'search');
        }

        const searchURL = new URL(baseUrl);

        const startDate = new Date();
        startDate.setHours(0,0,0,0);
        const endDate = new Date();
        endDate.setDate(startDate.getDate() +1);
        endDate.setHours(0,0,0,0);

        const optionsObj = {
            "type": "ASSOCIATE",
            "startDate": startDate.getTime(),
            "endDate": endDate.getTime(),
        }

        const shareableLink = "/detailPage/" + loginId + '/' + JSON.stringify(optionsObj);
        searchURL.searchParams.set("shareableLink", shareableLink);
        return searchURL.href;
    };

    const onSort = (sortDetails) => {
        dispatch({
            type: 'SORT_DATA',
            data: {column: sortDetails.sortColumn, direction: sortDetails.sortDirection}
        })
    }

    const sortedAssociatePerformance = [...viewModel.associatePerformance];
    sortedAssociatePerformance && sortedAssociatePerformance.sort((a, b) => {
        if (a[viewModel.sortPref.column] < b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? -1 : 1
        }
        if (a[viewModel.sortPref.column] > b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? 1 : -1
        }
        return 0
    })

    return (
        <div>
            <Row widths="100%" alignmentVertical="top">
                <div>
                    <RefreshTimer deps={[viewModel]}/>
                    <br/>
                    <div style={{ overflowX: "auto", width: "100%" }}>
                        <Table headerRows={1} spacing="small"
                           sortColumn={viewModel.sortPref.column}
                           sortDirection={viewModel.sortPref.direction}
                           onSort={onSort} fixHeaderRows={true} fixHeaderRowsFullWidth={true}
                           headerColumns={1} stickyHeaderColumn={true}>
                            <TableRow>
                                <TableCell sortColumn="alias">
                                    <FormattedMessage id="associate.associate" defaultMessage="Associate"/>
                                </TableCell>
                                <TableCell sortColumn="PPH" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.pph" defaultMessage="PPH"/>
                                </TableCell>
                                <TableCell sortColumn="hourSpent" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.hours" defaultMessage="Hours"/>
                                </TableCell>
                                <TableCell sortColumn="packageHandled" alignmentHorizontal="right">
                                    <FormattedMessage id="associate.total_packages" defaultMessage="Total Packages"/>
                                </TableCell>
                                <TableCell sortColumn="active">
                                    <FormattedMessage id="associate.active" defaultMessage="Active"/>
                                </TableCell>
                                <TableCell sortColumn="location">
                                    <FormattedMessage id="associate.location" defaultMessage="Location"/>
                                </TableCell>
                            </TableRow>
                            {sortedAssociatePerformance.map(associate => (
                                (states.length === 0 || states.includes(associate.active)) ? (
                                    <TableRow key={associate.alias}>
                                        <TableCell>
                                            <Link href={getAssociateLink(associate.email)} type="secondary" target="_blank" rel="noreferrer noopener">
                                                {getAliasFromLoginId(associate.alias)}
                                            </Link>
                                        </TableCell>
                                        <TableCell alignmentHorizontal="right">{associate.PPH}</TableCell>
                                        <TableCell alignmentHorizontal="right">{associate.hourSpent}</TableCell>
                                        <TableCell alignmentHorizontal="right">{associate.packageHandled}</TableCell>
                                        <TableCell>{associate.active}</TableCell>
                                        <TableCell>{associate.location}</TableCell>
                                    </TableRow>
                                ) : null
                            ))}

                        </Table>
                    </div>
                </div>
            </Row>
        </div>
    );
}

export default AssociatePerformance


// WEBPACK FOOTER //
// ./src/components/associate/AssociatePerformance.js